import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";

export default function MapTiltButton({ mapData, mapsData, mapSideNavTabState, tilted, setTilted, siteId }) {
  const rotateCWRef = useRef(null);
  const rotateCCWRef = useRef(null);
  const tiltRef = useRef(null);
  const controlRef = useRef(null);
  const mapControlContainerRef = useRef(null);

  const [currentHeading, setCurrentHeading] = useState(0);

  const mapSideNavTabStateValue = mapSideNavTabState.get();

  if (!mapControlContainerRef.current) {
    mapControlContainerRef.current = document.createElement("div");
  }

  useEffect(() => {
    if (!mapData) return;

    const controls = mapData.controls[mapsData.ControlPosition.RIGHT_BOTTOM];
    const container = mapControlContainerRef.current;

    if (!controls.getArray().includes(container)) {
      controls.push(container);
    }

    return () => {
      const index = controls.getArray().indexOf(container);
      if (index > -1) {
        controls.removeAt(index);
      }
    };
  }, [mapData, mapsData.ControlPosition.RIGHT_BOTTOM]);

  useEffect(() => {
    if (!mapData) return;

    if (["Action Zones", "Site Setup", "History"].includes(mapSideNavTabStateValue)) {
      mapData.setTilt(0);
      setTilted(false);
      return;
    }

    var tiltValue = localStorage.getItem(mapSideNavTabStateValue + siteId);
    if (tiltValue != null) {
      tiltValue = Number(tiltValue);
      
      if (tiltValue === 0) {
        setCurrentHeading(0);
        mapData.setHeading(0);
        setTilted(false);
      } else {
        setTilted(true);
      }

      mapData.setTilt(tiltValue);
    } else {
      mapData.setTilt(45);
    }
  }, [mapSideNavTabStateValue, mapData]);

  // Tilt button click
  const handleTiltClick = () => {
    if (["Action Zones", "Site Setup", "History"].includes(mapSideNavTabStateValue)) {
      mapData.setTilt(0);
      setTilted(false);
      return;
    }

    const newTilt = mapData.getTilt() === 0 ? 45 : 0;

    localStorage.setItem(mapSideNavTabStateValue + siteId, newTilt);

    if (newTilt === 0) {
      setCurrentHeading(0);
      mapData.setHeading(0);
      setTilted(false);
    } else {
      setTilted(true);
    }

    mapData.setTilt(newTilt);
  };

  // CW rotate
  const handleRotateCW = () => {
    const newHeading = (currentHeading + 90) % 360;
    setCurrentHeading(newHeading);
    mapData.setHeading(newHeading);
  };

  // CCW rotate
  const handleRotateCCW = () => {
    const newHeading = (currentHeading - 90 + 360) % 360;
    setCurrentHeading(newHeading);
    mapData.setHeading(newHeading);
  };

  return mapControlContainerRef.current
    ? createPortal(
      <div
        ref={controlRef}
        style={{
          margin: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "6px"
        }}
      >
        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
          {tilted && (
            <>
              <button
                ref={rotateCWRef}
                onClick={handleRotateCW}
                style={btnStyle}
                title="Rotate map clockwise"
              >
                ↻
              </button>

              <button
                ref={rotateCCWRef}
                onClick={handleRotateCCW}
                style={btnStyle}
                title="Rotate map counterclockwise"
              >
                ↺
              </button>
            </>
          )}
        </div>

        <button
          ref={tiltRef}
          onClick={handleTiltClick}
          style={btnStyle}
          title="Tilt Map"
        >
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 540 540" width="15" height="15" fill="currentColor">
            <path d="M480 160L352 160L352 288L480 288L480 160zM544 288L544 480C544 515.3 515.3 544 480 544L160 544C124.7 544 96 515.3 96 480L96 160C96 124.7 124.7 96 160 96L480 96C515.3 96 544 124.7 544 160L544 288zM160 352L160 480L288 480L288 352L160 352zM288 288L288 160L160 160L160 288L288 288zM352 352L352 480L480 480L480 352L352 352z" />
          </svg>
        </button>
      </div>,
      mapControlContainerRef.current)
    : null;
}

const btnStyle = {
  background: "#fff",
  padding: "8px 12px",
  border: "2px solid #fff",
  cursor: "pointer",
  borderRadius: "4px",
  boxShadow: "0 2px 6px rgba(0,0,0,.3)"
};
